const base = process.env.VUE_APP_URL

// process.env.VITE_AXIOS_BASE_URL
console.log(process.env)
const qiweiAPI = {
    getClockInData: base + 'CustomerVisit/getClockInData', //获取用户打卡数据
    getCustomersData: base + 'CustomerVisit/getCustomersData', //获取客户数据
    getOpportunityData: base + 'CustomerVisit/getOpportunityData', //获取客户商机数据
    getTripData: base + 'CustomerVisit/getTripData', //获取客户出差数据
    getuserinfo: base + 'CustomerVisit/getuserinfo', //获取用户员工号
    getUserData: base + 'CustomerVisit/getUserData', //获取用户员工号
    interviewSignIn: base + 'CustomerVisit/interviewSignIn', //上传打卡面访信息
    getSignInList: base + 'CustomerVisit/getSignInList', //面访记录
    getSignInDetails: base + 'CustomerVisit/getSignInDetails', //面访记录详情
    getMediaData: base + 'CustomerVisit/getLocalClockInData', //获取打卡图片素材
    getIndustryClassData: base + 'CustomerVisit/getIndustryClassData', //获取行业分类
    getDeviceCustome: base + 'CustomerVisit/getDeviceCustomer', // 高开工列表
    noFollowUp: base + 'CustomerVisit/noFollowUp', //暂不跟进
    // 科乐收
    KeLeShouCustomersData: base + 'KeLeShou/getCustomersData', //获取客户数据
    KeLeShouOpportunityData: base + 'KeLeShou/getOpportunityData', //获取客户商机数据
    KeLeShouChannelData: base + 'KeLeShou/getChannelData', //获取客户渠道
    KeLeShousubmitReport: base + 'KeLeShou/submitReport', //提交数据
    KeLeShouSignInList: base + 'KeLeShou/getSignInList', //获取拜访记录
    KeLeShouSignInDetails: base + 'KeLeShou/getSignInDetails', //获取拜访记录详情
    KeLeShougetuserinfo: base + 'KeLeShou/getuserinfo', //获取用户员工号
    KeLeShougetClockInData: base + 'KeLeShou/getClockInData', //获取用户打卡数据
    KeLeShouUserData: base + 'KeLeShou/getUserData', //获取用户员工号

}
module.exports = {
    qiweiAPI: qiweiAPI,
}


// WEBPACK FOOTER //
// ./src/api/qiwei.js